var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatterClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4h-3a.5.5 0 00-.5.5V5h4v-.5a.5.5 0 00-.5-.5zM9 4.5V5H6.571C4.587 5 3 6.626 3 8.605v7.79C3 18.374 4.587 20 6.571 20H17.43C19.413 20 21 18.374 21 16.395v-7.79C21 6.626 19.413 5 17.429 5H15v-.5A1.5 1.5 0 0013.5 3h-3A1.5 1.5 0 009 4.5zM10.5 7h6.929C18.284 7 19 7.706 19 8.605v7.79c0 .899-.716 1.605-1.571 1.605H6.57C5.716 18 5 17.294 5 16.395v-7.79C5 7.706 5.716 7 6.571 7H10.5zm-.621 1.964l.707.708L12 11.086l1.414-1.414.707-.708 1.415 1.415-.708.707-1.414 1.414 1.414 1.414.708.707-1.415 1.414-.707-.707L12 13.914l-1.414 1.414-.707.707-1.415-1.414.708-.707 1.414-1.414-1.414-1.414-.708-.707L9.88 8.964z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatterClose);
export default __webpack_public_path__ + "static/media/matter-close.7ca57683.svg";
export { ForwardRef as ReactComponent };